type Supporter = {
  count: number;
  createdUnixTimestamp: number;
  name: string;
  price: number;
  key: string;
};

export type FetchPodcastSupportersResponse = {
  supporters: Supporter[];
};

async function fetchPodcastSupporters(): Promise<FetchPodcastSupportersResponse> {
  try {
    const response = await fetch('/api/proxy/v3/stations/supporters', {
      method: 'GET',
      credentials: 'same-origin',
    });

    if (response.ok) {
      return await response.json();
    }

    throw new Error('Could not fetch podcast supporters');
  } catch (err) {
    throw new Error(err.message);
  }
}

export { fetchPodcastSupporters };
